import { SET_SITE_INFO } from './set-site-info';

export default (state = {}, action = {}) => {
  switch (action.type) {
    case SET_SITE_INFO:
      return action.payload;
    default:
      return state;
  }
};
